<!--
  Webchat logo/avatar (RF-04). Image Upload pattern of .claude/rules/11-web-ui-hyper.md: global
  `.upload-area`, preview with the avatar classes (round, as the widget header shows it).
-->
<div class="upload-area mb-0">
  @if (uploading) {
    <loading-component class="loading" diameter="30" />
  }

  @if (logoUrl) {
    <div class="upload-area__image" [class.opacity-50]="uploading">
      <img
        [src]="logoUrl"
        [alt]="'channel.webchatLogoUpload.imageAlt' | translate"
        class="img-thumbnail avatar-lg rounded-circle object-fit-cover"
        (error)="onImageError($event)"
      />
      <button
        type="button"
        class="btn btn-outline-danger"
        [disabled]="disabled || uploading"
        [attr.aria-label]="'channel.webchatLogoUpload.remove' | translate"
        (click)="remove()"
      >
        <i class="mdi mdi-trash-can-outline"></i>
      </button>
    </div>
  } @else {
    <div
      class="placeholder-content"
      role="button"
      tabindex="0"
      [attr.aria-disabled]="disabled || uploading"
      [class.opacity-50]="uploading"
      (click)="pickFile()"
      (keydown.enter)="pickFile()"
    >
      <i class="mdi mdi-cloud-upload-outline upload-icon text-primary"></i>
      <p class="text-primary mb-1">{{ "channel.webchatLogoUpload.clickToUpload" | translate }}</p>
      <p class="text-muted mb-0">{{ "channel.webchatLogoUpload.hint" | translate }}</p>
    </div>
  }

  <input #fileInput type="file" accept="image/jpeg, image/png" (change)="onFileSelected($event)" />
</div>
